import { Clock, Gauge, DollarSign, AlertTriangle } from "lucide-react";

const urgencyColor = {
  High: "text-red-400 border-red-500/40 bg-red-500/10",
  Medium: "text-amber-400 border-amber-500/40 bg-amber-500/10",
  Low: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10",
};

const Chip = ({ icon: Icon, children, className = "", testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 border px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-sm font-mono text-[10px] sm:text-[11px] uppercase tracking-wider ${className}`}>
    <Icon size={12} /> {children}
  </span>
);

export const FaqBadges = ({ faq, compact = false }) => (
  <div className="flex flex-wrap gap-1.5 sm:gap-2">
    <Chip icon={AlertTriangle} className={urgencyColor[faq.urgency]} testId={`urgency-badge-${faq.slug}`}>
      {faq.urgency} urgency
    </Chip>
    <Chip icon={Gauge} className="text-slate-300 border-[#27303E]">{faq.difficulty}</Chip>
    {!compact && <Chip icon={DollarSign} className="text-slate-300 border-[#27303E]" testId="cost-badge">{faq.cost}</Chip>}
    {!compact && <Chip icon={Clock} className="text-slate-300 border-[#27303E]">{faq.time}</Chip>}
  </div>
);
